import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, Input, model, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ErrorType } from '../../../auth/page-not-found/page-not-found.component';
import { IConfig } from '@onlyoffice/document-editor-angular';
import { Driver, driver } from 'driver.js';
import { MenuItem, MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogComponent } from 'src/app/@core/components/ui/dialog/dialog.component';
import { DialogService } from 'src/app/@core/services/dialog.service';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DragDropModule } from 'primeng/dragdrop';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { PanelModule } from 'primeng/panel';
import { PopoverModule } from 'primeng/popover';
import { SelectModule } from 'primeng/select';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from 'primeng/tooltip';
import { Subscription, take } from 'rxjs';
import { IconSourceEnum } from 'src/app/@core/components/ui/icon/icon.component';
import { CustomMenuItem } from 'src/app/@core/components/ui/menu/menu.component';
import { environment } from '../../../../environments/environment.dev';
import { AutoCompleteComponent } from '../../../@core/components/ui/autocomplete/autocomplete.component';
import { ButtonComponent } from '../../../@core/components/ui/button/button.component';
import { ZardResizablePanelComponent } from '../../../@core/components/ui/resizable/resizable-panel.component';
import { ZardResizableComponent } from '../../../@core/components/ui/resizable/resizable.component';
import { ITabPanelConfig, TabsPanelsComponent } from '../../../@core/components/ui/tabs-panels/tabs-panels.component';
import { COMMENTS_TYPE, FILE_TYPE, ONLY_OFFICE_EDITOR_TYPE, USER_ROLE, USER_TYPE } from '../../../@core/models/enums';
import { CaptureResult, CONTRACT_USER_ROLE, IAttachment, IDocumentVersion, IMilestone, IProject, IShareContract, IShareUser, IStatus, IUser, IWorkspace, MILESTONE_TYPE, SHARE_ACCESS, SHARE_FEATURE, STATUS_TYPE } from '../../../@core/models/model';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { BlurScreenService } from '../../../@core/services/blur-screen.service';
import { ProductWalkThroughService } from '../../../@core/services/product-walk-through.service';
import { CLIENT_EVENTS, SOCKET_EVENTS, SocketService } from '../../../@core/services/socket.service';
import { ToastService } from '../../../@core/services/toast.service';
import { FLOW_TYPE } from "../../../@shared/components/approval-workflow/approval-workflow.component";
import { CONTRACT_SIGNATORY_STATUS, CONTRACT_STATUS } from '../../../@shared/components/badge/badge.enums';
import { CaptureIssueComponent } from '../../../@shared/components/capture-issue/capture-issue.component';
import { InnformQuestionSidepanelComponent } from "../../../@shared/components/innform-question-sidepanel/innform-question-sidepanel.component";
import { OnlyOfficeDocEditorComponent } from '../../../@shared/components/only-office-doc-editor/only-office-doc-editor.component';
import { ShareAccessDialogComponent } from '../../../@shared/components/share-to-users/components/share-access-dialog/share-access-dialog.component';
import { SupportTicketFormComponent } from '../../../@shared/components/support-ticket-form/support-ticket-form.component';
import { CONTRACT_APPROVAL_STATUS } from "../../../@shared/components/user-chips/user-chips.component";
import { UserAvatarPipe } from '../../../@shared/pipes/user-avatar-pipe';
import { ScreenRecordingService } from '../../../@shared/services/screen-recording.service';
import { SupportTicketDialogService } from '../../../@shared/services/support-ticket-dialog.service';
import { SVG, TOP_BAR_SVG } from '../../../common/svgs';
import { validateEmail } from '../../../common/utils';
import { CommentService } from '../../../services/comment.service';
import { DASHBOARD_SCREEN, IContract, IContractApprovalConf, IContractComment, IContractSignatoryConf, IFormAnswer, PRODUCT_WALKTHROUGH_TYPE, SIGNATORY_TYPE } from '../../models/contract-management.model';
import { ApprovalConfService } from '../../services/approval-conf.service';
import { AUDIT_MODULE } from '../../services/audit-log.service';
import { ContractSignatoryService } from '../../services/contract-signatory.service';
import { DOCUMENT_CREATION_SOURCE, ContractService } from '../../services/contracts.service';
import { EditContractDataService } from '../../services/edit-contract-data.service';
import { JWTService } from '../../services/jwt.service';
import { MileStoneService } from '../../services/milestone.service';
import { OrganizationSetupFormService } from '../../services/organization-setup-from.service';
import { SharedSourcesService } from '../../services/question-sources.service';
import { ShareContractService } from '../../services/share-contract.service';
import { ShareService } from '../../services/share.service';
import { StatusService } from '../../services/status.service';
import { UserService } from '../../services/user.service';
import { VersionService } from '../../services/version.service';
import { ChatSource } from "../chat/chat.component";
import { CreateContractComponent } from '../create-contract/create-contract.component';
import { MilestonesComponent } from '../milestones/milestones.component';
import { DownloadDocComponent } from "./components/download-doc/download-doc.component";
import { ContractTopBarComponent, ContractTopBarView } from "./components/contract-top-bar/contract-top-bar.component";
import { createTabsConfig, EditContractTabConfig } from './tabs/tab-config';
import { AssetUrlPipe } from 'src/app/@shared/pipes/asset-url.pipe';
import { UserNameDisplayComponent } from 'src/app/@shared/components/user-name-display';
import { ZardResizableHandleComponent } from "src/app/@core/components/ui/resizable/resizable-handle.component";
import { ChatBubbleComponent } from 'src/app/@shared/components/chat-bubble/chat-bubble.component';
import { ChatSidebarService } from 'src/app/features/chat/services/chat-sidebar.service';
@Component({
  selector: 'app-edit-contract',
  standalone: true,
  imports: [AvatarGroupModule, ButtonComponent, AvatarModule, ButtonModule, UserAvatarPipe, SelectModule, MenuModule, PanelModule,
    PopoverModule, UserAvatarPipe, CheckboxModule, FormsModule, ConfirmPopupModule, MenubarModule, AutoCompleteComponent, DragDropModule,
    MatDialogModule, DialogComponent, CommonModule, InputIconModule, IconFieldModule, InputTextModule, DownloadDocComponent, OnlyOfficeDocEditorComponent,
    TimelineModule, InnformQuestionSidepanelComponent, MilestonesComponent, SupportTicketFormComponent, TooltipModule,
    TabsPanelsComponent, RouterModule, ShareAccessDialogComponent, ZardResizableComponent, ZardResizablePanelComponent, ZardResizableHandleComponent, CaptureIssueComponent, AssetUrlPipe, UserNameDisplayComponent, ContractTopBarComponent, ChatBubbleComponent],
  templateUrl: './edit-contract.component.html',
  styleUrl: './edit-contract.component.scss',
  providers: []
})
export class EditContractComponent implements AfterViewInit, OnInit, OnDestroy {

  //#region ViewChild References
  @ViewChild('onlyOfficeDocEditor') onlyOfficeDocEditor!: OnlyOfficeDocEditorComponent;
  @ViewChild('editableContent', { static: false }) editableContent!: ElementRef;
  @ViewChild('supportTicketForm') supportTicketFormComponent!: SupportTicketFormComponent;
  @ViewChild('captureIssue') captureIssueComponent!: CaptureIssueComponent;
  //#endregion

  //#region Input Properties
  @Input() activeQuestionId: string = '';
  @Input() currentSources: any[] = [];
  //#endregion

  //#region Constants & Enums
  CONTRACT_STATUS = CONTRACT_STATUS;
  USER_TYPE = USER_TYPE;
  CONTRACT_SIGNATORY_TYPE = SIGNATORY_TYPE;
  CONTRACT_APPROVAL_STATUS = CONTRACT_APPROVAL_STATUS;
  CONTRACT_USER_ROLE = CONTRACT_USER_ROLE;
  ContractTopBarView = ContractTopBarView;
  USER_ROLE = USER_ROLE;
  ChatSource = ChatSource;
  COMMENTS_TYPE = COMMENTS_TYPE;
  SHARE_FEATURE = SHARE_FEATURE;
  SHARE_ACCESS = SHARE_ACCESS;
  AUDIT_MODULE = AUDIT_MODULE;
  flowType = FLOW_TYPE;
  //#endregion

  //#region Panel & Layout Configuration
  panelSizes: number[] = [70, 30];
  minPanelSizes: number[] = [0, 25];
  PANEL_SIZE_KEY = 'editor-panel-sizes';
  FORM_PANEL_SIZE_KEY = 'form-panel-sizes';
  rightSidebarVisible: boolean = true;
  showQuestionPanel: boolean = false;
  questionSidePanelActiveTabIndex = model<string>('0');
  isResizing: boolean = false;
  //#endregion

  //#region Route & Basic State
  htmlContent: string = "";
  contractId: string = "";
  userId: string = "";
  projectId: string = "";
  navigationSource: string = "";
  loading: boolean = true;
  versionLoading: boolean = false;
  emptyDocument: boolean = true;
  isRefreshing: boolean = false;
  //#endregion

  //#region Contract & Document Data
  contract!: IContract & { containsForm: boolean };
  fileUrl: string | null = null;
  config: IConfig = {};
  markdownContent: string | null = null;
  lastModified: string = '';
  docUpdatedAt!: string;
  versions: IDocumentVersion[] = [];
  //#endregion

  //#region Workspace & User Data
  currentWorkspace: IWorkspace | null = null;
  currentUser!: IUser | null;
  createdBy!: IUser | null;
  users: IUser[] = [];
  autoCompleteUsers: any[] = [];
  isAnonymousUser: boolean = false;
  visitorId!: string;
  contractWorkspaceId: string | null = null;
  //#endregion

  //#region Permissions & Roles
  currentRole: string = '';
  role: string = '';
  fetchingRole: boolean = true;
  isOwner: boolean = false;
  isEditor: boolean = false;
  isSameOrganization: boolean = false;
  permissions: {
    canView: boolean,
    canEdit: boolean,
    canComment: boolean,
    restricted: boolean
  } = {
      canView: false,
      canEdit: false,
      canComment: false,
      restricted: true
    };
  //#endregion

  //#region Tabs Configuration
  tabsConfig: EditContractTabConfig[] = [];
  activeTabValue: string = '0';
  //#endregion

  //#region Approval Workflow
  approvalConf!: IContractApprovalConf;
  approvers: (IShareUser & { profilePicture?: IUser['profilePicture'] })[] = [];
  allApprovers: IShareUser[] = [];
  selectedApprovers: IUser[] = [];
  currentApprover: any;
  approver: boolean = false;
  approversDialog: boolean = false;
  labelText: string = 'Send for Approval';
  actionButton: boolean = false;
  bottomBarVisible: boolean = false;
  isCurrentUserReviewedDoc: boolean = false;
  //#endregion

  //#region Signatory Workflow
  signatoryConf!: IContractSignatoryConf;
  signatories: { email: string, name: string, status: string, user: string | IUser, type: USER_TYPE }[] = [];
  allSignatories: { email: string, name: string, status: string }[] = [];
  signatoryType = SIGNATORY_TYPE.DOCU_SIGN;
  disableAddSignatories: boolean = false;
  signatoryEmail: string = "";
  signatoryName: string = "";
  signatoryEmailValidation: boolean = false;
  signatoryDialog: boolean = false;
  //#endregion

  //#region Share & Access
  sharedUsers: IShareUser[] = [];
  shareDetails!: IShareContract;
  docUserRoles: SHARE_ACCESS[] = [];
  externalDocument: boolean = false;
  organizationName: string = '';
  shareAccessData: {
    user: Partial<IUser>,
    visible: boolean,
    orgLevel: boolean,
    workspaceLevel: boolean,
    resource: string,
    feature: SHARE_FEATURE,
    permissions: SHARE_ACCESS[],
    onComplete: Function,
  } = {
      user: {},
      visible: false,
      orgLevel: false,
      workspaceLevel: false,
      resource: '',
      feature: SHARE_FEATURE.CONTRACT,
      permissions: [SHARE_ACCESS.VIEW, SHARE_ACCESS.EDIT, SHARE_ACCESS.COMMENT],
      onComplete: () => { },
    };
  workspaces: IWorkspace[] = [];
  //#endregion

  //#region Comments
  comments: IContractComment[] = [];
  //#endregion

  //#region Dialogs & Modals
  milestonesDialog: boolean = false;
  supportTicketDialog: boolean = false;
  openDownloadContract: boolean = false;
  showVersionsHistoryDialog: boolean = false;
  isExpanded: boolean = false;
  isRecording: boolean = false;
  SVG = SVG;
  displayCustomDialog = false;
  dialogHeader = '';
  dialogMessage = '';
  pendingAction: 'Approve' | 'Reject' | 'Reset' | 'Skip' | 'Download' = 'Approve';
  approvalActionLoading: boolean = false;
  rejectionComment: string = '';
  workspaceMismatchDialog: boolean = false;
  //#endregion

  //#region Due Date
  showDueDateCalendar: boolean = false;
  selectedDueDate: Date | null = null;
  currentDate: Date = new Date();
  //#endregion

  //#region Project & Milestones
  project: IProject | null = null;
  projectDueDate: Date | null = null;
  milestones: IMilestone[] = [];
  //#endregion

  //#region Status Management
  loadingStatuses: boolean = false;
  documentStatuses: IStatus[] = [];
  selectedStatus: IStatus | null = null;
  statusMenuItems: (MenuItem & { active: boolean })[] = [];
  //#endregion

  //#region Menu & UI State
  items: MenuItem[] | undefined;
  menuOpen = false;
  menuItems: MenuItem[] = [
    {
      label: 'File',
      items: [{
        label: 'New',
        icon: 'pi pi-file-plus',
        command: () => { this.createNewDocument() }
      }, {
        label: 'Open',
        icon: 'pi pi-folder-open',
        command: () => { this.openCreateDialog() }
      }, {
        label: 'Download',
        icon: 'pi pi-download',
        items: [{
          label: 'PDF',
          icon: 'pi pi-file-pdf',
        },
        {
          label: 'Word',
          icon: 'pi pi-file-word',
        }]
      }]
    }
  ];
  supportMenuItems: CustomMenuItem[] = [
    {
      icon: SVG.RAISE_A_TICKET,
      iconSource: IconSourceEnum.SVG,
      label: 'Raise a support ticket',
      callback: () => {
        this.openHelp();
      }
    },
    {
      icon: SVG.CAPTURE_AN_ISSUE,
      iconSource: IconSourceEnum.SVG,
      label: 'Capture an issue',
      callback: () => {
        this.openCapture();
      }
    }
  ];
  TOP_BAR_SVG = TOP_BAR_SVG;
  infoMenuItems: CustomMenuItem[] = [
    {
      icon: TOP_BAR_SVG.DOCUMENTATION,
      iconSource: IconSourceEnum.SVG,
      label: 'Documentation',
      callback: () => {
        window.open('http://help.doc.inncircles.ai/', '_blank');
      }
    },
    {
      icon: TOP_BAR_SVG.WEBINARS,
      iconSource: IconSourceEnum.SVG,
      label: 'Webinars',
      callback: () => {
        window.open('https://inncircles.com/join-webinar/', '_blank');
      }
    },
    {
      icon: TOP_BAR_SVG.WHATS_NEW,
      iconSource: IconSourceEnum.SVG,
      label: "What's New",
      callback: () => {
        window.open('https://inncircles.ai/blogs/', '_blank');
      }
    },
    {
      icon: TOP_BAR_SVG.QUICK_TOUR,
      iconSource: IconSourceEnum.SVG,
      label: 'Quick Tour',
      callback: () => {
        this.resetWalkthrough();
      }
    }
  ];
  //#endregion

  //#region Autocomplete & Input
  autoCompleteValue: any = '';
  //#endregion

  //#region Drag & Drop
  draggedApproverIdx: any;
  editApprover: { [key: number]: boolean } = {};
  //#endregion

  //#region Tour/Walkthrough
  driver!: Driver;
  walkThroughSubscription!: Subscription;
  currentStepNumber = 0;
  //#endregion

  //#region Subscriptions
  private commentsSubscription!: Subscription;
  signatoryUpdatedSubscription!: Subscription;
  documentUpdatedSubscription!: Subscription;
  documentFormQuestionExtractedSubscription!: Subscription;
  documentFormAnswerExtractedSubscription!: Subscription;
  //#endregion

  //#region Services & Utils
  dialog = inject(MatDialog);
  private jwtService = new JWTService();
  subscriptionDetails: any;
  i: any;
  sidepanelSources: IFormAnswer['sources'] = [];
  //#endregion

  isProject: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private messageService: MessageService, private contractService: ContractService, private contractSignatoryService: ContractSignatoryService,
    private dialogService: DialogService,
    private userService: UserService,
    private authService: AuthenticationService,
    public approvalService: ApprovalConfService,
    public commentService: CommentService,
    private toast: ToastService,
    private shareService: ShareContractService,
    private versionService: VersionService,
    private socketService: SocketService,
    private productWalkThroughService: ProductWalkThroughService,
    private sharedSourcesService: SharedSourcesService,
    private statusService: StatusService,
    private milestoneService: MileStoneService,
    private organizationService: OrganizationSetupFormService,
    private editContractDataService: EditContractDataService,
    private shareAccessService: ShareService,
    private blurScreenService: BlurScreenService,
    private supportTicketDialogService: SupportTicketDialogService,
    private screenRecordingService: ScreenRecordingService,
    private chatSidebarService: ChatSidebarService,
  ) {
    this.organizationService.currentWorkspace.subscribe(res => this.currentWorkspace = res)
    this.authService.currentUser.subscribe(res => {
      this.currentUser = res as IUser
      this.isAnonymousUser = res?.anonymous ?? false;
    });
    this.route.queryParamMap.subscribe(params => {
      this.htmlContent = params.get('htmlContent') as string ?? ""
      const documentId = params.get('documentId') as string ?? ""
      if (documentId && !this.isValidObjectId(documentId)) {
        this.router.navigate(['/not-found'], { queryParams: { error: ErrorType.INVALID_URL } });
        return;
      }
      this.contractId = documentId;
      this.userId = params.get('user') as string ?? ""
      this.navigationSource = params.get('source') ?? "";
      const projectId = params.get('projectId') as string ?? ""
      if (projectId && !this.isValidObjectId(projectId)) {
        this.router.navigate(['/not-found'], { queryParams: { error: ErrorType.INVALID_URL } });
        return;
      }
      this.projectId = projectId;
      this.isProject = this.projectId ? true : false;
    });

    this.emitSocketEvent(CLIENT_EVENTS.JOIN_CONTRACT_ROOM)
    // Register contract room for automatic reconnection
    if (this.contractId) {
      this.socketService.registerRoom(`contract_${this.contractId}`, CLIENT_EVENTS.JOIN_CONTRACT_ROOM, this.contractId);
    }
    this.contractService.getAiGeneratedContent().pipe(take(1)).subscribe(res => {
      this.markdownContent = res
      this.contractService.setAiGeneratedContent('')
    })
    this.getUsers()
  }

  //#region Lifecycle Hooks
  ngOnInit() {
    this.initializeData();

    this.screenRecordingService.recordingState$.subscribe(state => {
      this.isRecording = state.isRecording;
    });

    this.supportTicketDialogService.openDialog$.subscribe(payload => {
      if (payload.attachment && this.supportTicketFormComponent) {
        this.supportTicketFormComponent.attachmentFiles.push(payload.attachment.file);
        this.supportTicketFormComponent.attachmentPreviews.push(payload.attachment);
      }
      this.supportTicketDialog = true;
    });
  }

  async initializeData() {
    sessionStorage.setItem('homeDefaultTab', DASHBOARD_SCREEN.DOCUMENTS);
    this.signatoryUpdatedSubscription = this.socketService.on(SOCKET_EVENTS.SIGNATORIES_UPDATED).subscribe(res => {
      this.fetchContractSignatories()
    })
    this.documentUpdatedSubscription = this.socketService.on<{ updatedAt: string }>(SOCKET_EVENTS.DOCUMENT_SAVED).subscribe(res => {
      if (res) this.docUpdatedAt = res[0].updatedAt
    })
    this.loadPanelSizes();
    await this.getSharedDetails();
    this.getLastModified()
    this.fetchAllComments()
    this.commentsSubscription = this.commentService.commentsObservable$.subscribe(() => {
      this.fetchAllComments();
    });
    this.getVersions()
    this.items = [
      {
        label: 'Quick tour',
        icon: 'pi pi-globe'
      },
    ]
    await Promise.all([
      this.fetchContract(),
      this.getContractApprovers(),
      this.fetchContractSignatories(),
      this.getWorkspaces()
    ])
    this.checkIfSameWorkspace()
    this.checkIfExternalShare()
    this.initializeTabsConfig()
    this.updateDataService()
    this.getOrganizationName()
  }

  ngAfterViewInit(): void {
    this.approvalChange()

    setTimeout(() => {
      const tourType = this.currentUser?.productWalkThrough?.find(walkthrough => walkthrough.type === PRODUCT_WALKTHROUGH_TYPE.EDITOR);
      if (!tourType?.status) {
        this.initializeTour();
      }
    });
    this.walkThroughSubscription = this.productWalkThroughService.walkThroughReset$.subscribe(type => {
      if (type == PRODUCT_WALKTHROUGH_TYPE.EDITOR) {
        this.initializeTour()
      }
    })
  }

  ngOnDestroy(): void {
    if (this.chatSidebarService.isOpen()) {
      this.chatSidebarService.close();
    }
    if (this.commentsSubscription) {
      this.commentsSubscription.unsubscribe();
    }

    if (this.signatoryUpdatedSubscription) {
      this.signatoryUpdatedSubscription.unsubscribe();
    }

    if (this.documentUpdatedSubscription) {
      this.documentUpdatedSubscription.unsubscribe();
    }

    if (this.driver) this.driver.destroy();

    this.emitSocketEvent(CLIENT_EVENTS.LEAVE_CONTRACT_ROOM)
    // Unregister contract room
    if (this.contractId) {
      this.socketService.unregisterRoom(`contract_${this.contractId}`);
    }
  }
  //#endregion

  //#region Initialization Methods
  initializeTabsConfig() {
    this.tabsConfig = createTabsConfig(
      this.contract,
      this.currentRole,
      this.isAnonymousUser || !this.isSameOrganization,
      CONTRACT_USER_ROLE
    );
  }

  updateDataService() {
    this.editContractDataService.setData({
      parent: this,
      contractId: this.contractId,
      contract: this.contract,
      currentRole: this.currentRole,
      projectId: this.projectId,
      emptyDocument: this.emptyDocument,
      currentStepNumber: this.currentStepNumber,
      approvalConf: this.approvalConf,
      allApprovers: this.allApprovers,
      isOwner: this.isOwner,
      isEditor: this.isEditor,
      permissions: this.permissions,
      signatoryConf: this.signatoryConf,
      allSignatories: this.allSignatories,
      disableAddSignatories: this.disableAddSignatories,
      signatoryType: this.signatoryType,
      milestones: this.milestones
    });
  }

  get canEditStatus(): boolean {
    return !this.loadingStatuses && this.documentStatuses.length > 0 && (this.isEditor || this.isOwner)
  }

  getWorkspaces() {
    this.organizationService.getWorkspaces().subscribe({
      next: (res) => {
        if (res.success) {
          this.workspaces = res.data;
        } else {
          this.workspaces = [];
        }
      },
      error: (error) => {
        console.error('Error fetching workspaces:', error);
        this.workspaces = [];
      }
    })
  }

  checkIfSameWorkspace() {
    if (!this.contract) return;

    const contractWorkspaceId = typeof this.contract.workspace === 'string'
      ? this.contract.workspace
      : this.contract.workspace?._id;
    const currentWorkspaceId = this.currentWorkspace?._id;

    const hasAccessToContractWorkspace = this.workspaces.some(workspace => workspace._id === contractWorkspaceId);

    if (
      (contractWorkspaceId && contractWorkspaceId !== currentWorkspaceId) &&
      hasAccessToContractWorkspace &&
      this.isSameOrganization &&
      !this.permissions.restricted &&
      !this.isAnonymousUser
    ) {
      this.contractWorkspaceId = contractWorkspaceId;
      this.workspaceMismatchDialog = true;
    }
  }

  switchToContractWorkspace() {
    if (!this.contractWorkspaceId || !this.currentUser?._id) {
      this.toast.error('Unable to switch workspace');
      return;
    }

    this.userService.updateUser({
      _id: this.currentUser._id,
      currentWorkspace: this.contractWorkspaceId
    }).subscribe((res) => {
      if (res.success) {
        this.authService.setUserData(res.data);
        this.blurScreenService.enableBlur();
        this.workspaceMismatchDialog = false;
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        this.toast.error('Failed to switch workspace');
      }
    });
  }

  checkIfExternalShare() {
    const checkExternal = (items: IShareUser[]) => items.some((item) => item.type === USER_TYPE.EXTERNAL)

    this.externalDocument = checkExternal(this.approvalConf.approvers) ||
      checkExternal(this.signatoryConf.signatories) ||
      checkExternal(this.shareDetails.users)
  }

  getOrganizationName() {
    this.organizationService.fetchOrganizationSetupData().subscribe(res => {
      this.organizationName = res.data?.name
    })
  }
  //#endregion

  //#region Socket & Event Management
  async emitSocketEvent(event: CLIENT_EVENTS) {
    const socket = await this.socketService.getSocket()
    if (!socket) {
      console.warn('Socket is not initialized yet:', event)
      return
    }
    socket.emit(event as CLIENT_EVENTS.JOIN_CONTRACT_ROOM | CLIENT_EVENTS.LEAVE_CONTRACT_ROOM, this.contractId)
  }
  //#endregion

  //#region Panel Management
  loadPanelSizes(key = this.PANEL_SIZE_KEY) {
    const storedSizes = localStorage.getItem(key);
    if (storedSizes) {
      try {
        const panelSizes = JSON.parse(storedSizes);
        if (Array.isArray(panelSizes) && panelSizes.length == 2 && typeof panelSizes[0] === 'number' && typeof panelSizes[1] === 'number') {
          this.panelSizes = panelSizes;
        }
      } catch (err) {
        return;
      }
    }
  }

  onResizeStart() {
    this.isResizing = true;
  }

  onResizing() {
    // This fires during resize - keep it lightweight
    // The overlay prevents iframe interaction
  }

  onResizeEnd(event: { sizes: number[], layout: 'horizontal' | 'vertical' }) {
    this.isResizing = false;
    localStorage.setItem(this.contract?.containsForm ? this.FORM_PANEL_SIZE_KEY : this.PANEL_SIZE_KEY, JSON.stringify(event.sizes));
  }
  //#endregion

  //#region Tour/Walkthrough Methods
  resetWalkthrough() {
    // Always switch to insights tab (value '0') before starting the tour
    this.activeTabValue = '0';
    this.initializeTour();
  }

  initializeTour() {

    let elementsToWait: string[] = [];
    if ((this.isOwner || (this.isSameOrganization && this.permissions.canEdit)) && !this.contract?.containsForm) {
      elementsToWait = ['[step-id="step2"]', '[step-id="step3"]', '[step-id="step4"]', '[step-id="step5"]'];
    }
    else if ((this.isOwner || (this.isSameOrganization && this.permissions.canEdit)) && this.contract?.containsForm) {
      elementsToWait = ['[step-id="step5"]'];
    }
    else {
      elementsToWait = ['[step-id="step6"]'];
    }
    Promise.all(elementsToWait.map(selector => this.waitForElement(selector)))
      .then(() => {
        let steps = [
          { element: '[step-id="step1"]', popover: { title: 'Status', description: 'Check and update the current status of the document to understand its progress at a glance.', side: "left" as const, align: 'start' as const } },
          ...((this.isOwner || (this.isSameOrganization && this.permissions.canEdit)) ?
            [{ element: '[step-id="step2"]', popover: { title: 'Upload Document', description: 'Seamlessly upload your construction documents to the platform. Drag and drop file or select from your device to get started.', side: "left" as const, align: 'start' as const } },
            { element: '[step-id="step3"]', popover: { title: 'Versions', description: 'Keep a detailed record of document changes by accessing and previewing previous versions.', side: "left" as const, align: 'center' as const } },
            { element: '[step-id="step4"]', popover: { title: 'Due Date', description: 'View when this document is due to ensure timely completion.', side: "left" as const, align: 'center' as const } },
            { element: '[step-id="step5"]', popover: { title: 'Share document', description: 'Securely share construction documents with internal and external stakeholders while maintaining full control over role based user permissions.', side: "left" as const, align: 'start' as const } },
            ] : []
          ),
          ...((this.isOwner || this.isEditor) ? [{ element: '[step-id="step6"]', popover: { title: 'Send for Approval', description: 'Submit documents for review and approval by authorized stakeholders, ensuring a structured and efficient approval process.', side: "left" as const, align: 'center' as const } },
          ] : []),
          { element: '[step-id="step7"]', popover: { title: 'Generate Insights', description: 'Extract key information from your document with a single click. Use this feature to analyze updates and gain meaningful insights whenever content is modified.', side: "bottom" as const, align: 'start' as const } },
          { element: '[step-id="step8"]', popover: { title: 'Summary', description: 'Quickly access a comprehensive overview of the document, highlighting key details and essential information.', side: "left" as const, align: 'start' as const } },
          { element: '[step-id="step9"]', popover: { title: 'Tags', description: 'Identify critical data extracted from the document based on customized requirements, ensuring quick accessibility of information.', side: "left" as const, align: 'start' as const } },
          { element: '[step-id="step10"]', popover: { title: 'Checklist Items', description: 'Review predefined checklists, compliance rate, and risk assessments to ensure document alignment project requirements.', side: "bottom" as const, align: 'center' as const } },
          { element: '[step-id="step11"]', popover: { title: 'AI Tooling', description: 'Leverage AI to simplify complex content, making documents easier to understand and work with.', side: "bottom" as const, align: 'start' as const } },
          { element: '[step-id="step12"]', popover: { title: 'Compare', description: 'Effortlessly analyze multiple documents with AI-powered comparison. Gain a consolidated summary, track key performance indicators, and engage with InnDoc AI Chat Bot for contextual insights.', side: "left" as const, align: 'start' as const } },
          { element: '[step-id="step13"]', popover: { title: 'Questionnaire', description: 'View all questions from your form and manage every action in one place.', side: "bottom" as const, align: 'start' as const } },
          { element: '[step-id="step14"]', popover: { title: 'Approvers', description: 'Define and manage approvers within the workflow, ensuring a structured review process for document approval or rejection.', side: "left" as const, align: 'start' as const } },
          { element: '[step-id="step15"]', popover: { title: 'Signatories', description: 'Configure and manage designated signatories within the workflow to ensure an organized and authorized document signing process.', side: "left" as const, align: 'start' as const } },
          { element: '[step-id="step17"]', popover: { title: 'Linked Files', description: 'Need to connect related documents? Easily link existing files for quick access or let AI assist you in generating a new document effortlessly.', side: "bottom" as const, align: 'start' as const } },
          { element: '[step-id="step18"]', popover: { title: 'Milestones', description: 'Set up and track key milestones over time to monitor your project’s progress.', side: "bottom" as const, align: 'start' as const } },
          { element: '[step-id="step19"]', popover: { title: 'Comments', description: 'Collaborate in real-time by adding feedback, suggestions, and discussions', side: "bottom" as const, align: 'start' as const } },
          { element: '[step-id="step20"]', popover: { title: 'History', description: 'Review all past changes made to this document, including edits and updates.', side: "left" as const, align: 'start' as const } },
          ...(this.contract?.containsForm ? [{ element: '[step-id="step21"]', popover: { title: 'Edit', description: 'Edit the document settings to update fields or adjust configurations', side: "bottom" as const, align: 'start' as const } }] : []),
          ...(this.contract?.containsForm ? [{ element: '[step-id="step22"]', popover: { title: 'Download', description: 'Download your form along with all questions and responses in a clean, ready-to-share format.', side: "bottom" as const, align: 'start' as const } }] : []),
          ...(this.contract?.containsForm ? [{ element: '[step-id="step23"]', popover: { title: 'Ask Bob', description: 'Engage with the InnDoc AI chatbot to ask questions, seek clarifications, and interact on document-related queries for efficient assistance.', side: "bottom" as const, align: 'start' as const } }] : []),
        ]
        steps = steps.filter(step => {
          const element = document.querySelector(step.element);
          return element !== null;
        });

        this.driver = driver({
          stageRadius: 14,
          showProgress: true,
          nextBtnText: 'Next',
          allowClose: true,
          prevBtnText: 'Previous',
          onCloseClick: () => this.completeTour(),
          onDestroyed: () => this.completeTour(),
          popoverClass: 'custom-popover',
          showButtons: ['next', 'previous'],
          steps: steps,
          onHighlightStarted: (element) => {
            if (!element) return;

            const stepId = element.getAttribute('id');
            if (!stepId) return;

            const stepNumber = parseInt(stepId.replace('step', ''), 10);
            this.currentStepNumber = stepNumber;
            if (stepNumber >= 11 && stepNumber <= 14) {
              (element as HTMLElement).click();
            }
            if (stepNumber == 10) {
              const insightsElement = document.getElementById("prevOfApprover");
              insightsElement?.click();
            }
          },

        });
        //});
        const element = document.getElementById((this.isOwner || (this.isSameOrganization && this.permissions.canEdit)) ? 'step1' : 'step5');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        // Start the tour after scrolling
        setTimeout(() => this.driver.drive(), 300);
      });
  }

  completeTour() {
    this.currentStepNumber = 0;
    let data = { type: PRODUCT_WALKTHROUGH_TYPE.EDITOR, status: true };
    this.userService.updateWalkThrough(data).subscribe(() => {
    });
  }

  waitForElement(selector: string, timeout = 5000): Promise<void> {
    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if (document.querySelector(selector)) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(interval);
        reject(new Error(`Element not found: ${selector}`));
      }, timeout);
    });
  }
  //#endregion

  //#region Support & Dialogs
  toggleIcon() {
    this.isExpanded = !this.isExpanded;
  }

  openHelp() {
    this.supportTicketDialog = true;
  }

  openJiraSupportServiceDesk() {
    this.supportTicketDialog = true;
  }

  openCapture() {
    this.captureIssueComponent.openCaptureDialog();
  }

  onCaptureCompleted(result: CaptureResult) {
    this.supportTicketDialog = true;
    setTimeout(() => {
      if (this.supportTicketFormComponent) {
        this.supportTicketFormComponent.attachmentFiles.push(result.file);
        this.supportTicketFormComponent.attachmentPreviews.push(result);
      }
    }, 0);
  }

  closeSupportTicketDialog() {
    // Clear the description field when dialog closes
    if (this.supportTicketFormComponent) {
      this.supportTicketFormComponent.clearDescription();
    }
    this.supportTicketDialog = false;
  }

  onSupportTicketSubmitted() {
    this.supportTicketDialog = false;
  }

  onSupportTicketDialogHide() {
    if (this.supportTicketFormComponent) {
      this.supportTicketFormComponent.resetForm();
    }
    this.supportTicketDialog = false;
  }
  //#endregion

  //#region Document & File Management
  getDocumentFormat(attachment: IAttachment): FILE_TYPE {
    switch (attachment?.type) {
      case 'application/pdf':
        return FILE_TYPE.PDF
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return FILE_TYPE.WORD
      default:
        return FILE_TYPE.WORD
    }
  }

  getEditorTypeForFile(fileType: FILE_TYPE): ONLY_OFFICE_EDITOR_TYPE {
    switch (fileType) {
      case FILE_TYPE.WORD:
        return ONLY_OFFICE_EDITOR_TYPE.WORD
      case FILE_TYPE.PDF:
        return ONLY_OFFICE_EDITOR_TYPE.PDF
      default:
        return ONLY_OFFICE_EDITOR_TYPE.WORD
    }
  }

  fetchContractURL(url?: string, key?: string) {
    if (this.contractId.length > 0) {
      this.contractService.getContractURL(this.contractId).subscribe(async res => {
        if (res.success) {
          this.fileUrl = url ? url : res.data.url;
          let docFormat = this.getDocumentFormat(res.data.attachment as IAttachment)
          let editorType = this.getEditorTypeForFile(docFormat)
          url = url ? url : res.data.url
          key = key ? key : res.data.key
          const tokenConfig: Partial<IConfig> = {
            document: {
              fileType: docFormat as string,
              key: this.contractId + "-" + key,
              title: this.contract.name,
              url: url,
              permissions: {
                chat: this.permissions.canEdit,
                comment: this.permissions.canComment,
                download: true,
                edit: this.permissions.canEdit,
                fillForms: true,
                modifyContentControl: true,
                modifyFilter: true,
                print: true,
                protect: true,
                review: this.permissions.canComment,
                //reviewGroups: [],
                userInfoGroups: [],
              },
            },
            documentType: editorType,
            editorConfig: {
              user: {
                group: this.contractId,
                id: this.currentUser?.email,
                image: this.currentUser?.profilePicture?.url ? `${environment.s3Url}/${this.currentUser.profilePicture.url}?timestamp=${new Date().getTime()}` : '',
                name: this.currentUser?.firstName + ' ' + this.currentUser?.lastName
              },
              embedded: {
                toolbarDocked: "top",
              },
              customization: {
                toolbarHideFileName: true,
                hideRightMenu: true,
                compactToolbar: true,
                compactHeader: true,
                comments: true,
                forcesave: true,
                uiTheme: "theme-gray",
                logo: {
                  image: `${environment.s3Url}/inndoc-ai/assets/images/3.png`,
                },
                zoom: -2, // Fit to width { -1 for fit to page and -2 for fit to width}
              },
              callbackUrl: environment.apiUrl + '/public/save-contract-document' + "?contractId=" + this.contractId + "&userId=" + this.currentUser?._id,
            },
            height: "100%",
            width: "100%",
          }
          const token = this.jwtService.signToken(tokenConfig, environment.jwtSecret);
          this.config = {
            ...tokenConfig,
            token: token
          };
        }
      });
    } else {
      this.toast.error('No document found , try uploading again !')
    }
  }

  createNewDocument() {
    const form: FormData = new FormData();
    form.append('name', 'Untitled');

    this.contractService.createContract(form).subscribe((res) => {
      if (res.success && res.data) {
        const url = this.router.createUrlTree(['edit-document'], {
          queryParams: { 'documentId': res.data._id }
        }).toString();


        window.open(url, '_blank');
      }
    });
  }

  openCreateDialog() {
    const _dialogRef = this.dialog.open(CreateContractComponent, {
      disableClose: true,
      minWidth: '40rem',
      data: { contractId: this.contractId }
    });

    _dialogRef.afterClosed().subscribe(response => {
      if (response) {
        // this.contractEditor.insertHTML(response)
        window.location.reload();
      }
    })
  }

  isEmptyDocument($event?: boolean) {
    if ($event !== undefined) {
      this.emptyDocument = $event
      // Update the service so child components get the new value
      this.editContractDataService.updateData({ emptyDocument: $event });
      this.chatSidebarService.updateConfig({ embeddingsStatus: !this.emptyDocument && !this.isRefreshing });
      return
    }
    this.contractService.isEmptyDoc(this.contractId).subscribe(res => {
      this.emptyDocument = res.data.isEmpty
      // Update the service so child components get the new value
      this.editContractDataService.updateData({ emptyDocument: res.data.isEmpty });
      this.chatSidebarService.updateConfig({ embeddingsStatus: !this.emptyDocument && !this.isRefreshing });
    })
  }

  onContractRefreshingChange(value: boolean) {
    this.isRefreshing = value;
    this.chatSidebarService.updateConfig({ embeddingsStatus: !this.emptyDocument && !this.isRefreshing });
  }

  openDownloadDailog(status: boolean) {
    this.openDownloadContract = status
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const text = event.clipboardData?.getData('text/plain');
  }
  //#endregion

  //#region Version Management

  toggleVersionsHistoryDialog() {
    this.router.navigate(['versions'], { queryParams: { 'documentId': this.contractId } })
    // this.getVersions()
    // this.showVersionsHistoryDialog = !this.showVersionsHistoryDialog
  }

  saveVersion() {
    this.versionService.saveVersion(this.contract._id).subscribe(res => {
      if (res.success) {
        this.toast.success('Version Saved Successfully')
      }
    })
  }

  getVersions() {
    this.versionService.getVersions(this.contractId).subscribe(res => {
      if (res.success) {
        this.versions = res.data.versions
      }
    })
  }

  showVersion(item: IDocumentVersion) {
    if (item.file && item.file.url) {
      this.versionService.getDocVersionURL(this.contract._id, item.version).subscribe(res => {
        if (res.success) {
          this.fetchContractURL(res.data.url, res.data.key)
          this.toggleVersionsHistoryDialog()
        }
      })

    }
  }

  downloadVersion(versionId: string, index: number) {
    this.versionLoading = true;
    this.versionService.downloadVersion(this.contract._id, versionId).subscribe(res => {
      if (res.success) {
        this.downloadDocument(res.data.data, `${this.contract.name} - Version${this.versions.length - index}`, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        this.versionLoading = false;
      }
    })
  }

  deleteVersion(versionId: string) {
    this.versionService.deleteVersion(this.contract._id, versionId).subscribe(res => {
      if (res.success) {
        this.toast.success('Version Deleted Successfully')
        this.getVersions()
      }
    })
  }
  //#endregion

  //#region Contract Management
  async fetchContract() {
    if (this.contractId.length > 0) {
      return new Promise((resolve, reject) => {
        this.contractService.fetchContract(this.contractId).subscribe((res) => {
          if (res.success) {
            this.contract = res.data;
            if (this.contract.containsForm) {
              this.panelSizes = [50, 50];
              this.minPanelSizes = [0, 35];

              // ⛔ Only load stored panel sizes if sidepanel is hidden
              if (!this.showQuestionPanel) {
                this.loadPanelSizes(this.FORM_PANEL_SIZE_KEY);
              }
            }

            this.docUpdatedAt = res.data.updatedAt;
            this.fetchContractURL();
            this.signatoryType = res.data?.defaultSignature;

            if (!res.data.defaultSignature) {
              this.fetchSignatorySetting();
            }

            this.checkContractStatus();
            this.isSameOrganization = this.currentUser?.organization === this.contract.organization;
            this.isEmptyDocument();
            this.fetchDocumentStatuses();
            this.getMilestones();
            this.project = res.data.project ? res.data.project : null;
            this.projectId = this.projectId || this.project?._id || '';
            this.projectDueDate = this.project?.dueDate ? new Date(this.project.dueDate) : null;
            this.selectedDueDate = this.contract.dueDate ? new Date(this.contract.dueDate) : null;
            // Update service with latest contract data
            this.editContractDataService.updateData({ contract: this.contract });
            resolve(true);
          } else {
            reject('No contract found');
          }
        });
      })
    } else {
      this.toast.error('No contract found');
      return Promise.reject('No contract found');
    }
  }

  getLastModified() {
    this.loading = true;
    this.fetchContract()
    setTimeout(() => {
      this.loading = false
    }, 1000)
  }

  blurSpan(event: Event) {
    const target = event.target as HTMLElement;
    target.blur();
  }

  updateContractName(event: Event) {
    event.preventDefault()
    const target = event.target as HTMLElement;
    const newName = target.textContent?.trim() || 'Untitled';
    target.innerHTML = newName
    if (this.contract && this.contract.name !== newName) {
      const updateData = { ...this.contract, name: newName };
      this.updateContract(updateData);
    }
  }

  updateContract(contract: IContract) {
    if (contract && contract._id) {
      const existingLinkedDocType = this.contract?.linkedDocType;
      this.contractService.updateContract(contract._id, contract).subscribe(res => {
        this.contract = res.data;
        if (!this.contract?.linkedDocType?.name && existingLinkedDocType) {
          this.contract.linkedDocType = existingLinkedDocType;
        }
        this.selectedDueDate = this.contract.dueDate ? new Date(this.contract.dueDate) : null;
        if (res && res.success) {
          this.toast.success('Contract updated successfully');
        } else {
          this.toast.error('Failed to update contract');
        }
      })
    }
  }

  checkContractStatus() {
    if (this.contractId.length > 0) {
      this.contractService.fetchContract(this.contractId).subscribe((res) => {
        this.contract = res.data
        this.selectedDueDate = this.contract.dueDate ? new Date(this.contract.dueDate) : null;
        this.editContractDataService.updateData({ contract: this.contract });
        switch (this.contract?.status) {
          case CONTRACT_STATUS.DRAFT:
            this.labelText = 'Send for Approval';
            this.actionButton = true;
            break;

          case CONTRACT_STATUS.READY_FOR_APPROVAL:
            this.labelText = 'Send for Approval';
            this.actionButton = false;
            break;

          case CONTRACT_STATUS.SIGNATURE_IN_PROGRESS:
          case CONTRACT_STATUS.PENDING_APPROVAL:
            this.labelText = 'Publish';
            this.actionButton = true;
            break;

          case CONTRACT_STATUS.APPROVED:
            this.labelText = 'Publish';
            this.actionButton = true;
            break;
          case CONTRACT_STATUS.READY_FOR_SIGNATURE:
          case CONTRACT_STATUS.SIGNATORY_REJECTED:
            this.labelText = 'Publish';
            if ((this.signatoryConf?.signatories ?? []).length > 0) this.actionButton = false;
            else this.actionButton = true;
            break;
        }
      });
    }

  }

  reviewDocument() {
    this.dialogService.confirm({
      title: 'Are you sure?',
      description: `This action will mark the document as ${!this.isCurrentUserReviewedDoc ? 'reviewed' : 'not reviewed'} by you. Do you want to proceed?`,
      confirmText: 'Yes', cancelText: 'No',
    }).subscribe(confirmed => {
      if (confirmed) {
        this.contractService.reviewDocument(this.contractId, !this.isCurrentUserReviewedDoc).subscribe(res => {
          if (res.success) {
            this.toast.success(`Document marked as ${!this.isCurrentUserReviewedDoc ? 'reviewed' : 'not reviewed'}!`);
            this.checkContractStatus();
            this.isCurrentUserReviewedDoc = !this.isCurrentUserReviewedDoc;
          }
        });
      }
    });
  }


  goBack() {
    const docTypeId = this.contract?.linkedDocType
    switch (this.navigationSource) {
      case DOCUMENT_CREATION_SOURCE.CONTRACT_GENERATION:
      case DOCUMENT_CREATION_SOURCE.STANDARD:
        this.router.navigate(['/explore/generate-with-ai'], {
          queryParams: docTypeId ? { docTypeId } : {}
        });
        break;
      default:
        if (this.isProject) {
          this.router.navigate(['/projects/dashboard'], { queryParams: { projectId: this.projectId } });
        } else {
          this.router.navigate(['/documents']);
        }
    }
  }

  openProject() {
    if (this.projectId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/projects/dashboard'], { queryParams: { projectId: this.projectId } })
      );
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  navigateToLogin() {
    this.router.navigate(['/login']);
  }
  //#endregion

  //#region Milestones Management
  getMilestones() {
    this.milestoneService.getMilestones(MILESTONE_TYPE.DOCUMENT, undefined, this.contractId).subscribe(res => {
      if (res.success) {
        this.milestones = res.data;
        // Update service with latest milestones
        this.editContractDataService.updateData({ milestones: this.milestones });
      }
    });
  }


  onMilestoneSave(event: { edited: Partial<IMilestone>[]; deleted: string[] }) {
    this.milestoneService.updateMilestones(event.edited, event.deleted, MILESTONE_TYPE.DOCUMENT, undefined, this.contractId).subscribe(res => {
      if (res.success) {
        this.toast.success('Milestones updated successfully.');
        this.milestonesDialog = false;
        this.getMilestones();
      } else {
        this.toast.error('Failed to update milestones.');
      }
    });
  }
  onMilestoneCancel() {
    this.milestonesDialog = false;
  }

  toggleMilestonesDialog() {
    this.milestonesDialog = !this.milestonesDialog
  }
  //#endregion

  //#region Due Date Management
  toggleDueDateCalendar() {
    if (this.currentRole !== CONTRACT_USER_ROLE.OWNER && !this.isEditor) {
      return;
    }
    this.showDueDateCalendar = !this.showDueDateCalendar;
    if (this.showDueDateCalendar) {
      this.selectedDueDate = this.contract.dueDate ? new Date(this.contract.dueDate) : null;
    }
  }

  handleDueDateSelect(event: any) {
    if (event.value && !Array.isArray(event.value)) {
      this.onDueDateSelect(event.value);
    }
  }

  onDueDateSelect(event: Date) {
    this.selectedDueDate = event;
    this.updateContractDueDate();
    this.showDueDateCalendar = false;
  }

  closeDueDateCalendar() {
    this.showDueDateCalendar = false;
  }

  updateContractDueDate() {
    if (this.contractId) {
      const dueDate = this.selectedDueDate || undefined;
      this.contractService.updateContract(this.contractId, { dueDate: dueDate }).subscribe(res => {
        if (res.success) {
          this.contract.dueDate = dueDate;
          this.toast.success("Due Date updated successfully");
        } else {
          this.toast.error("Error updating Due Date");
        }
      });
    }
  }

  isSelectedPastDate(date: any): boolean {
    if (!this.selectedDueDate) return false;

    const selectedDate = new Date(this.selectedDueDate);
    selectedDate.setHours(0, 0, 0, 0);
    const checkDate = new Date(date.year, date.month, date.day);
    checkDate.setHours(0, 0, 0, 0);

    return checkDate.getTime() === selectedDate.getTime() &&
      checkDate < this.currentDate;
  }

  checkDueDatePassed(date: Date | string | null): boolean {
    if (!date) return false;
    const dueDate = new Date(date);
    dueDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return dueDate.getTime() < today.getTime();
  }

  isDueToday(date: Date | string | null): boolean {
    if (!date) return false;
    const dueDate = new Date(date);
    const today = new Date();
    return dueDate.getFullYear() === today.getFullYear() &&
      dueDate.getMonth() === today.getMonth() &&
      dueDate.getDate() === today.getDate();
  }
  //#endregion

  //#region Signatory Settings
  fetchSignatorySetting() {
    this.contractSignatoryService.getDefaultSignatory().subscribe(res => {
      if (res.success) {
        this.signatoryType = res.data?.defaultSignatory
      }
    })
  }
  //#endregion

  //#region Share & Permissions Management
  async getSharedDetails() {
    return new Promise((resolve, reject) => {
      this.shareService.getShareDetails(this.contractId, SHARE_FEATURE.CONTRACT).subscribe(async (res) => {
        if (res.data) {
          this.shareDetails = res.data;
          this.sharedUsers = res.data.users;
          this.isCurrentUserReviewedDoc = this.shareDetails.users.find((user) => user.email == this.currentUser?.email)?.reviewed || false;
          // current user roles from share details
          this.docUserRoles = this.shareDetails.users.find((user) => user.email == this.currentUser?.email)?.role as SHARE_ACCESS[] || [];
          await this.getPermissionOfUser();
          this.fetchingRole = false;
          resolve(true);
        } else {
          this.fetchingRole = false;
          reject('Failed to fetch share details');
        }
      },
        err => reject(err)
      );
    });
  }

  getPermissionOfUser() {
    return new Promise((resolve, reject) => {
      this.shareService.getPermissionOfUser(this.contractId, SHARE_FEATURE.CONTRACT).subscribe(res => {
        if (res.success) {
          this.permissions = res.data
          if (this.permissions.canEdit) {
            this.isEditor = true
            this.currentRole = CONTRACT_USER_ROLE.EDITOR
          } else if (this.permissions.canComment) {
            this.currentRole = CONTRACT_USER_ROLE.COMMENTER
          } else if (this.permissions.canView) {
            this.currentRole = CONTRACT_USER_ROLE.VIEWER
          }
          if (this.contract?.createdBy == this.currentUser?._id) {
            this.isOwner = true
            this.currentRole = CONTRACT_USER_ROLE.OWNER
          }
          // Update service with latest permissions and roles
          this.editContractDataService.updateData({
            permissions: this.permissions,
            isOwner: this.isOwner,
            isEditor: this.isEditor,
            currentRole: this.currentRole
          });
          resolve(true)
        } else {
          reject('Failed to fetch role');
        }
      })
    })

  }

  wsAndDocAccessCheck(user: Partial<IUser>, accept: Function) {
    this.shareAccessService.isShareUserHaveAccess(user, this.currentWorkspace?._id, SHARE_FEATURE.WORKSPACE).subscribe(res => {
      if (!res.data.hasAccess && this.currentWorkspace?._id) {
        this.shareAccessData.visible = true
        this.shareAccessData.user = user
        this.shareAccessData.orgLevel = true
        this.shareAccessData.workspaceLevel = false
        this.shareAccessData.resource = this.currentWorkspace._id
        this.shareAccessData.feature = SHARE_FEATURE.WORKSPACE
        this.shareAccessData.permissions = [SHARE_ACCESS.VIEW, SHARE_ACCESS.EDIT, SHARE_ACCESS.COMMENT]
        this.shareAccessData.onComplete = () => { this.wsAndDocAccessCheck(user, accept) }
        return;
      }
      accept()
    })
  }

  externalUserCheck(email: string, accept: Function) {
    const user = this.users.find((user) => user.email === email.trim())
    if (user) {
      this.wsAndDocAccessCheck(user, accept);
    } else {
      this.dialogService.confirm({
        title: 'Are you sure?',
        description: `The email address ${email} belongs to an external domain outside ${this.organizationName}. Please confirm you wish to proceed with sharing this item externally`,
        confirmText: 'Yes', cancelText: 'No',
      }).subscribe(confirmed => { if (confirmed) { accept(); } });
    }
  }
  //#endregion

  //#region User Management
  getUsers() {
    this.userService.getUsers().subscribe(res => {
      this.users = res.data.users
    })
  }

  autoCompleteUsersMethod(event: any) {
    this.autoCompleteUsers = this.users.filter((user: any) => {
      return (user.fullName.toLowerCase().includes(event.query.toLowerCase()) || user.email.toLowerCase().includes(event.query.toLowerCase()))
    })
  }

  isUserUnverified(item: any): boolean {
    return item && item.user && typeof item.user !== 'string' && item.user.verified === false;
  }
  //#endregion

  //#region Approval Workflow Management
  async getContractApprovers() {
    return new Promise((resolve, reject) => {
      this.approvalService.fetchContractApprovers(this.contractId).subscribe(res => {
        if (res.data && res.success) {
          this.approvalConf = res.data
          this.approvers = [...this.approvalConf.approvers]
          this.allApprovers = JSON.parse(JSON.stringify(this.approvalConf.approvers))
          this.currentApprover = (this.approvalConf?.approvers ?? []).find(approver => approver.email === this.currentUser?.email)
          this.bottomBarVisible = false
          if (this.currentApprover?.email == this.currentUser?.email) {
            if (this.currentApprover.status == CONTRACT_APPROVAL_STATUS.PENDING || !this.isSameOrganization) {
              this.bottomBarVisible = true
            } else if (this.isSameOrganization) {
              this.bottomBarVisible = false
            }
          }
          // Update service with latest approval data
          this.editContractDataService.updateData({
            approvalConf: this.approvalConf,
            allApprovers: this.allApprovers
          });
          resolve(true);
        } else {
          reject('No approval data found');
        }
      });
    })
  }

  saveApprovalWorkflow() {
    const approvers: IContractApprovalConf['approvers'] = this.approvers.map((approver) => {
      return {
        user: approver.user,
        email: approver.email,
        name: approver.name,
        status: CONTRACT_APPROVAL_STATUS.WAITING,
        type: approver.type
      }
    })
    this.approvalService.saveApprovalWorkflow(this.contractId, approvers).subscribe(res => {
      if (res.success) {
        this.toast.success('Approval Workflow Saved Successfully');
        this.approversDialog = false
        this.approvalChange()
      }
    });
  }

  getIconPath(): string {
    return this.labelText === 'Publish' ? '/icons/rocket.svg' : '/icons/user-check.svg';
  }

  selectApprover(user: any) {
    user.selected = !user.selected;
    if (user.selected) {
      this.selectedApprovers.push(user);
    } else {
      this.selectedApprovers = this.selectedApprovers.filter(u => u !== user);
    }
  }

  async approvalChange() {
    this.checkContractStatus()
    this.getContractApprovers()
    this.getUsers()
  }

  onApprovalChange(approvalConf: IContractApprovalConf) {
    this.approvers = approvalConf.approvers
    this.approvalConf = approvalConf
    this.checkContractStatus()
  }

  toggleApproveDialog() {
    this.approversDialog = !this.approversDialog
    this.getContractApprovers()
  }

  onCloseApproverDialog() {
    this.approversDialog = false
    this.approvers = []
    this.autoCompleteValue = ''
    this.editApprover = {}
  }

  addInternalApprover(event: any) {
    const user = event.value
    const findUser = this.approvers.find((approver: any) => approver.email === user.email)
    if (findUser) {
      this.toast.warn('User already added')
      this.autoCompleteValue = ''
      return
    }
    this.autoCompleteValue = ''
    this.externalUserCheck(user.email, () => {
      this.approvers.push({
        name: user.fullName,
        user: user,
        email: user.email,
        type: USER_TYPE.INTERNAL,
        profilePicture: user.profilePicture,
      })
    })
  }

  addExternalApprover() {
    const email = this.autoCompleteValue
    const findUser = this.approvers.find((approver: any) => approver.email === email)
    if (findUser) {
      this.toast.warn('User already added')
      this.autoCompleteValue = ''
      return
    }
    const addUser = () => {
      const user = this.users.find((user) => user.email === email)
      if (user) {
        this.autoCompleteValue = ''
        this.approvers.push({
          name: email.split('@')[0],
          email,
          user: user,
          type: USER_TYPE.INTERNAL,
        })
      }
      else {
        this.userService.getUserDetailsByEmail(email).subscribe(res => {
          if (res.success) {
            this.autoCompleteValue = ''
            this.approvers.push({
              name: email.split('@')[0],
              email,
              user: res.data.user,
              type: res.data.type,
            })
          }
        })
      }
    }
    this.externalUserCheck(email, addUser)
  }

  removeApprover(index: number, type: string) {
    if (type == 'approver') {
      this.approvers.splice(index, 1)
    } else if (type == 'signatory') {
      this.signatories.splice(index, 1)
    }
  }

  editApproverFunc(index: number) {
    this.editApprover[index] = !this.editApprover[index]
  }

  dragStart(index: number) {
    this.draggedApproverIdx = index;
  }

  drop(dropIndex: number) {
    if (this.draggedApproverIdx !== undefined && this.draggedApproverIdx !== null && this.draggedApproverIdx !== dropIndex) {
      const draggedApprover = this.approvers[this.draggedApproverIdx];
      this.approvers.splice(this.draggedApproverIdx, 1);
      this.approvers.splice(dropIndex, 0, draggedApprover);
      this.draggedApproverIdx = null;
    }
  }

  allowDrop(event: any) {
    event.preventDefault();
  }

  openApprovalDialog(action: 'Approve' | 'Reject') {
    this.pendingAction = action;
    this.dialogHeader = 'Are you sure?';
    this.dialogMessage = `Want to ${action} this document?`;
    this.rejectionComment = ''; // Reset comments
    this.displayCustomDialog = true;
  }

  openResetOrSkipConfirm(action: 'Reset' | 'Skip') {
    this.pendingAction = action;
    this.dialogHeader = 'Are you sure?';
    this.dialogMessage =
      action === 'Reset'
        ? 'This action will reset the approval flow for this document. Do you want to proceed?'
        : 'This action will skip the approval flow for this document. Do you want to proceed?';
    this.displayCustomDialog = true;
  }

  onConfirmDialogAccept() {
    if (this.pendingAction === 'Download') {
      this.displayCustomDialog = false;
      this.download();
      return;
    }
    this.approvalActionLoading = true;
    if (this.pendingAction === 'Approve') {
      this.approvalService.approveContract(this.contractId).subscribe(res => {
        if (res.success) {
          this.toast.success('Approved document successfully');
          this.checkContractStatus();
          this.getContractApprovers();
          this.displayCustomDialog = false;
          this.approvalActionLoading = false;
        }
        else {
          this.toast.error('Failed to approve document');
          this.approvalActionLoading = false;
        }
      });
    } else if (this.pendingAction === 'Reject') {
      if (this.rejectionComment.length == 0) {
        this.toast.error('Please enter rejection comment');
        return;
      }
      this.approvalService.rejectContract(this.contractId, this.rejectionComment).subscribe(res => {
        if (res.success) {
          this.displayCustomDialog = false;
          this.toast.success('Rejected document successfully');
          this.checkContractStatus();
          this.getContractApprovers();
          this.approvalActionLoading = false;
        } else {
          this.toast.error('Failed to reject document');
          this.approvalActionLoading = false;
        }
      });
    } else if (this.pendingAction === 'Reset') {
      this.approvalService.resetApprovalWorkflow(this.contractId).subscribe(res => {
        if (res.success) {
          this.toast.success('Reset Document Successfully ');
          this.getContractApprovers();
          this.checkContractStatus();
          this.displayCustomDialog = false;
        } else {
          this.toast.error('Failed to reset approval flow');
        }
        this.approvalActionLoading = false;
      });
    } else if (this.pendingAction === 'Skip') {
      this.approvalService.skipApprovalFlow(this.contractId).subscribe(res => {
        if (res.success) {
          this.getContractApprovers();
          this.checkContractStatus();
          this.displayCustomDialog = false;
        } else {
          this.toast.error('Failed to skip approval flow');
        }
        this.approvalActionLoading = false;
      });
    }
  }

  onConfirmDialogReject() {
    this.displayCustomDialog = false;
  }

  showReviewButton() {
    // If current user is not in current approval level or internal user
    if (this.isSameOrganization || this.isAnonymousUser) return false;
    if (this.currentApprover?.status === CONTRACT_APPROVAL_STATUS.PENDING) return false;
    return true;
  }

  resetApprovalFlow() {
    this.openResetOrSkipConfirm('Reset');
  }

  skipApprovalFlow() {
    this.openResetOrSkipConfirm('Skip');
  }
  //#endregion

  //#region Signatory Workflow Management
  async fetchContractSignatories() {
    return new Promise((resolve, reject) => {
      this.contractSignatoryService.fetchContractSignatories(this.contractId).subscribe(res => {
        if (res.success) {
          this.signatoryConf = res.data

          if (!this.signatoryConf) {
            this.signatoryConf = {} as never
            this.signatoryConf['signatories'] = []
            this.signatoryConf['status'] = CONTRACT_SIGNATORY_STATUS.NOT_YET_STARTED
          }

          switch (this.signatoryConf.status) {
            case CONTRACT_SIGNATORY_STATUS.NOT_YET_STARTED:
            case CONTRACT_SIGNATORY_STATUS.REJECTED:
              this.disableAddSignatories = false
              break;
            default:
              this.disableAddSignatories = true
          }
          this.allSignatories = this.signatoryConf.signatories
          this.signatories = this.signatoryConf.signatories.map((signatory) => {
            return {
              email: signatory.email,
              name: signatory.name,
              status: signatory.status,
              signedAttachment: signatory.signedAttachment,
              updatedAt: signatory.updatedAt,
              user: signatory.user,
              type: signatory.type
            }
          })
          this.checkContractStatus()
          // Update service with latest signatory data
          this.editContractDataService.updateData({
            signatoryConf: this.signatoryConf,
            allSignatories: this.allSignatories,
            disableAddSignatories: this.disableAddSignatories,
            signatoryType: this.signatoryType
          });
          resolve(true);
        } else {
          reject()
        }
      })
    })
  }

  toggleSignatoryDialog() {
    this.signatoryDialog = !this.signatoryDialog
    this.fetchContractSignatories()
  }

  onCloseSignatoryDialog() {
    this.signatoryDialog = false
    this.signatories = []
    this.autoCompleteValue = ''
    this.editApprover = {}
  }

  addSignatory(event: any) {
    const user = event.value
    const findUser = this.signatories.find((approver: any) => approver.email === user.email)
    if (findUser) {
      this.toast.warn('User already added')
      this.autoCompleteValue = ''
      return
    }
    this.autoCompleteValue = this.autoCompleteValue?.email ?? ''
    this.externalUserCheck(user.email, () => {
      this.signatories.push({
        email: user.email,
        name: user.fullName,
        status: CONTRACT_APPROVAL_STATUS.WAITING,
        user,
        type: USER_TYPE.INTERNAL
      })
      this.signatories = [...this.signatories]
      this.autoCompleteValue = ''
    })
  }

  updateSignatories() {
    this.contractSignatoryService.updateSignatories(this.contractId, this.signatories).subscribe(res => {
      if (res.success) {
        this.fetchContractSignatories()
        this.toggleSignatoryDialog()
      }
    })
  }

  updateName() {
    if (validateEmail(this.signatoryEmail)) this.signatoryEmailValidation = true
    else this.signatoryEmailValidation = false
    this.signatoryName = this.signatoryEmail.substring(0, this.signatoryEmail.lastIndexOf('@') == -1 ? this.signatoryEmail.length : this.signatoryEmail.lastIndexOf('@'));
  }

  addExternalSignatory() {
    const email = this.autoCompleteValue
    const findUser = this.signatories.find((approver: any) => approver.email === email)
    if (findUser) {
      this.toast.warn('User already added')
      this.autoCompleteValue = ''
      return
    }
    const addUser = () => {
      const user = this.users.find((user) => user.email === email)
      if (user) {
        this.signatories.push({
          name: email.split('@')[0],
          email,
          status: CONTRACT_APPROVAL_STATUS.WAITING,
          user: user,
          type: USER_TYPE.INTERNAL
        })
      } else {
        this.userService.getUserDetailsByEmail(email).subscribe(res => {
          if (res.success) {
            this.signatories.push({
              name: email.split('@')[0],
              email,
              status: CONTRACT_APPROVAL_STATUS.WAITING,
              user: res.data.user,
              type: res.data.type
            })
            this.autoCompleteValue = ''
          }
        })
      }
    }
    this.externalUserCheck(email, addUser)
  }

  removeSignatory(index: number) {
    this.signatories.splice(index, 1)
  }

  dropSignatories(dropIndex: number) {
    if (this.draggedApproverIdx !== undefined && this.draggedApproverIdx !== null && this.draggedApproverIdx !== dropIndex) {
      const draggedApprover = this.signatories[this.draggedApproverIdx];
      this.signatories.splice(this.draggedApproverIdx, 1);
      this.signatories.splice(dropIndex, 0, draggedApprover);
      this.draggedApproverIdx = null;
    }
  }

  async signatoryChange(email: string) {
    this.dialogService.confirm({
      title: 'Are you sure?',
      description: `This action will remove the signatory <span class="bg-gray-100 px-1.5 py-1 rounded-md">${email}</span> from the document. Do you want to proceed?`,
      confirmText: 'Yes', cancelText: 'No',
      confirmVariant: 'destructive',
    }).subscribe(confirmed => {
      if (confirmed) {
        this.signatories = this.signatories.filter((signatory) => signatory.email !== email);
        this.updateSignatories();
      }
    });
  }

  startSignatoryFlow() {
    this.toast.info('Document Sent for Signature');
    this.contractSignatoryService.startSignatoryFlow(this.contractId, this.signatoryType).subscribe(res => {
      if (res.success) {
        this.toast.success('Signatory Flow Started Successfully');
        this.fetchContractSignatories()
        this.actionButton = true
      } else {
        this.actionButton = false
        this.toast.warn(res.message)
      }
    })
  }

  resetSignatoryFlow() {
    this.dialogService.confirm({
      title: 'Are you sure?',
      description: `This action will stop the current ongoing signatory flow for this document. Do you want to proceed?`,
      confirmText: 'Yes', cancelText: 'No',
    }).subscribe(confirmed => {
      if (confirmed) {
        this.contractSignatoryService.resetSignatoryFlow(this.signatoryConf._id).subscribe(res => {
          if (res.success) {
            this.fetchContractSignatories();
          }
        });
      }
    });
  }

  action() {
    if (this.contract) {
      switch (this.contract.status) {
        case CONTRACT_STATUS.READY_FOR_APPROVAL:
          if (this.approvalConf?.approvers && this.approvalConf.approvers.length > 0) {
            this.approvalService.sendForApproval(this.contractId).subscribe((res) => {
              this.toast.success('Document Sent for Approval Successfully');
              this.approvalChange()
            });
          }
          break;

        case CONTRACT_STATUS.APPROVED:
          // this.contractService.sendForSign(this.contractId).subscribe((res) => {
          //   this.checkContractStatus()
          // });
          break;

        case CONTRACT_STATUS.READY_FOR_SIGNATURE:
          if (this.signatoryConf.signatories.length > 0) {
            this.startSignatoryFlow()
            this.actionButton = true;
          }
          break;
      }
    }
  }
  //#endregion

  //#region Download Methods
  downloadDocument(uint8Array: Uint8Array, fileName: string, mimeType?: string) {
    const blob: Blob = new Blob([new Uint8Array(uint8Array)], {
      type: mimeType ? mimeType : 'application/pdf'
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = mimeType ? `${fileName}.docx` : `${fileName}.pdf`;
    document.body.append(link);
    link.click();
    link.remove();
  }

  async downloadSignedDocument(event: { email: string, name: string, status: string, signedAttachment?: string }) {
    this.contractSignatoryService.downloadDocument(event.signedAttachment as string).subscribe({
      next: res => {
        if (res.success) {
          this.downloadDocument(res.data.data, `${event.name} - Signed Document - ${this.contract.name}`)
        } else {
          this.toast.error('Failed to download signed document')
        }
      },
      error: () => {
        this.toast.error('Failed to download signed document')
      }
    })
  }

  downloadContract() {
    if (!this.fileUrl) {
      this.toast.error('File URL not available');
      return;
    }
    this.pendingAction = 'Download';
    this.dialogHeader = 'Download Confirmation';
    this.dialogMessage = 'Make sure to save all your changes before downloading the document.';
    this.displayCustomDialog = true;
  }

  download() {
    // Show loading indicator
    this.loading = true;
    fetch(this.fileUrl as string)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        // Create blob URL
        const blobUrl = URL.createObjectURL(blob);

        // Create download link
        const link = document.createElement('a');
        link.href = blobUrl;

        // Determine file extension based on blob type or contract attachment
        let fileExtension = '';
        if (blob.type === 'application/pdf') {
          fileExtension = '.pdf';
        } else if (blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          fileExtension = '.docx';
        } else if (this.contract?.attachment && typeof this.contract.attachment === 'object' && this.contract.attachment.type) {
          // Fallback to contract attachment type
          if (this.contract.attachment.type.includes('pdf')) {
            fileExtension = '.pdf';
          } else if (this.contract.attachment.type.includes('word')) {
            fileExtension = '.docx';
          }
        }

        // Sanitize filename and add extension if not present
        let fileName = (this.contract.name || 'Document').replace(/[<>:"/\\|?*]/g, '_');
        if (fileExtension && !fileName.toLowerCase().endsWith(fileExtension)) {
          fileName += fileExtension;
        }

        link.download = fileName;

        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up blob URL
        URL.revokeObjectURL(blobUrl);

        this.loading = false;

        this.contractService.logDownloadContract(this.contractId).subscribe(res => {
          if (res.success) {
            this.toast.success('Document download successfully');
          }
        })
      })
      .catch(error => {
        this.toast.error('Failed to download file');
        this.loading = false;
      });
  }

  canDownloadDocument(): boolean {
    // anyone can download the document - Viewer, Editor, Admin, Owner
    // return this.currentRole === CONTRACT_USER_ROLE.OWNER || this.currentUser?.role === USER_ROLE.ADMIN || this.currentRole === PROJECT_USER_ROLE.MANAGER || this.isOwner || this.isEditor;
    return true;
  }
  //#endregion

  //#region Comments Management
  fetchAllComments() {
    this.commentService.getAllComments({ contractId: this.contractId }).subscribe(res => {
      if (res.success) {
        this.comments = res.data
      }
    })
  }
  //#endregion

  //#region Status Management
  fetchDocumentStatuses() {
    if (!this.contract?.linkedDocType?._id) {
      return;
    }
    this.loadingStatuses = true;
    this.statusService.getStatuses(STATUS_TYPE.DOCUMENT, this.contract.linkedDocType._id, undefined, this.contractId).subscribe(res => {
      if (res && res.success) {
        this.documentStatuses = res.data || [];
        this.selectedStatus = this.documentStatuses.find(status => status._id === this.contract.documentStatus) || null;
        this.getStatusMenuItems();
      }
      this.loadingStatuses = false;
    });
  }

  getStatusMenuItems() {
    this.statusMenuItems = this.documentStatuses.map(status => ({
      label: status.name,
      command: () => this.updateContractStatus(status),
      class: status._id === this.selectedStatus?._id ? 'bg-arena-orange-100 text-arena-orange' : '',
      active: status.active
    }));
  }

  onStatusItemClick(item: MenuItem, popover: any) {
    if (item.command) {
      item.command({ originalEvent: new Event('click'), item });
    }
    popover.hide();
  }

  updateContractStatus(status: IStatus) {
    if (!this.contract || status._id === this.contract.documentStatus) {
      return;
    }
    const updateData = { ...this.contract, documentStatus: status._id };
    this.contractService.updateContract(this.contract._id, updateData).subscribe(res => {
      if (res && res.success) {
        this.contract.documentStatus = status._id;
        this.docUpdatedAt = res.data.updatedAt;
        this.selectedStatus = status;
        this.fetchDocumentStatuses();
        this.getStatusMenuItems();
        this.toast.success(`Contract status updated to ${status.name}`);
      } else {
        this.toast.error('Failed to update contract status');
      }
    });
  }
  //#endregion

  //#region Tab & Side Panel Management
  onTabChanged(event: { value: string, tab: ITabPanelConfig }): void {
    this.activeTabValue = event.value;

    // Handle tour navigation if needed
    const tourTab = this.tabsConfig.find(t => t.value === event.value) as EditContractTabConfig;
    if (tourTab?.tour?.stepId) {
      const element = document.getElementById(tourTab.tour.stepId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  toggleQuestionPanel(showPanel: boolean, activeTabIndex: number = 0) {
    if (this.showQuestionPanel) {
      this.activeQuestionId = '';

    }
    this.showQuestionPanel = showPanel;
    this.questionSidePanelActiveTabIndex.set(activeTabIndex.toString());
    if (!this.showQuestionPanel) {
      this.loadPanelSizes(this.contract.containsForm ? this.FORM_PANEL_SIZE_KEY : this.PANEL_SIZE_KEY);
    }
  }

  onTabIndexChange(event: any) {

    // For onTabChange event, the structure is different - event.value contains the tab value
    // For click events, we use event.index
    let index: number;
    if (event.value !== undefined) {
      // This is from onTabChange event - event.value is the tab's [value] attribute
      index = parseInt(event.value);
    } else if (event.index !== undefined) {
      // This is from click event - event.index is the tab index
      index = event.index;
    } else {
      // Fallback
      index = 0;
    }

    this.commentService.tabActiveIndex = index;
  }

  onTabClick(index: number) {

    // Prevent event bubbling and set the tab index directly
    this.commentService.tabActiveIndex = index;
  }

  getCurrentSources(): { questionId: string, sources: IFormAnswer['sources'] } {
    return this.sharedSourcesService.getCurrentSources();
  }
  //#endregion

  //#region UI & Utility Methods
  handleClick(item: MenuItem) {
    if (item.label === 'Help') {
      this.openJiraSupportServiceDesk();
    } else if (item.label == 'Quick tour') {
      this.resetWalkthrough()
    }
    this.toggleMenu()
  }

  handleDueDateClear() {
    const contract = { ...this.contract, dueDate: undefined };
    this.contractService.updateContract(this.contractId, contract).subscribe(res => {
      if (res && res.success) {
        this.contract.dueDate = undefined;
        this.toast.success('Due Date cleared successfully');
      } else {
        this.toast.error('Error clearing Due Date');
      }
      this.showDueDateCalendar = false;
    });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  validApproverEmail() {
    return validateEmail(this.autoCompleteValue)
  }

  //#endregion

  //#region Role Display Helpers
  private getRolesArray(): SHARE_ACCESS[] {
    if (!this.docUserRoles) {
      return [];
    }
    // Handle both array and single value
    return Array.isArray(this.docUserRoles) ? this.docUserRoles : [this.docUserRoles];
  }

  getPrimaryRoles(): string[] {
    const roles = this.getRolesArray();
    const primaryRoles: string[] = [];

    if (roles.length === 0) {
      return [];
    }

    // Priority roles: VIEW, EDIT, COMMENT
    if (roles.includes(SHARE_ACCESS.ADMIN)) {
      primaryRoles.push('Admin');
    }
    if (roles.includes(SHARE_ACCESS.OWNER)) {
      primaryRoles.push('Owner');
    }
    if (roles.includes(SHARE_ACCESS.VIEW)) {
      primaryRoles.push('Viewer');
    }
    if (roles.includes(SHARE_ACCESS.EDIT)) {
      primaryRoles.push('Editor');
    }
    if (roles.includes(SHARE_ACCESS.COMMENT)) {
      primaryRoles.push('Commenter');
    }

    return primaryRoles;
  }

  getOnlyApproverSignatoryRoles(): string[] {
    const roles = this.getRolesArray();
    const approverSignatoryRoles: string[] = [];

    if (roles.length === 0) {
      return [];
    }

    if (roles.includes(SHARE_ACCESS.APPROVER)) {
      approverSignatoryRoles.push('Approver');
    }
    if (roles.includes(SHARE_ACCESS.SIGNATORY)) {
      approverSignatoryRoles.push('Signatory');
    }

    return approverSignatoryRoles;
  }

  getAdditionalRolesCount(): number {
    const roles = this.getRolesArray();
    if (roles.length === 0) {
      return 0;
    }

    let count = 0;
    if (roles.includes(SHARE_ACCESS.APPROVER)) {
      count++;
    }
    if (roles.includes(SHARE_ACCESS.SIGNATORY)) {
      count++;
    }

    return count;
  }

  getAdditionalRolesTooltip(): string {
    const roles = this.getRolesArray();
    if (roles.length === 0) {
      return '';
    }

    const additionalRoles: string[] = [];
    if (roles.includes(SHARE_ACCESS.APPROVER)) {
      additionalRoles.push('Approver');
    }
    if (roles.includes(SHARE_ACCESS.SIGNATORY)) {
      additionalRoles.push('Signatory');
    }

    return additionalRoles.join(', ');
  }

  getFormattedRoleDisplay(): string {
    const primaryRoles = this.getPrimaryRoles();
    const approverSignatoryRoles = this.getOnlyApproverSignatoryRoles();

    // If user has only approver/signatory roles (no primary roles), show only those
    if (primaryRoles.length === 0 && approverSignatoryRoles.length > 0) {
      return approverSignatoryRoles.join('/');
    }

    // If user has primary roles, show them
    if (primaryRoles.length > 0) {
      return primaryRoles.join('/');
    }

    // Fallback to currentRole if nothing else
    return this.currentRole;
  }
  //#endregion

  private isValidObjectId(id: string): boolean {
    return /^[a-fA-F0-9]{24}$/.test(id);
  }

}
